import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import './index.scss';
import axios from 'axios';
import { APIurl } from '../../App';
import TableUser from '../../components/TableUser';
import MSGDialogue from '../../components/Dialogue';
import EAAdviserInfo from './EA';

/* ================== Cards ================== */
function DashCards({ title, number }) {
  return (
    <div className="stats-card bg-white box-hover transition-all-1s animate__animated animate__fadeInDown">
      <div className="stats-title mb-4">{title}</div>
      <div className="stats-content d-flex flex-row">
        <div className="theme-color font-weight-bold m-1 stats-icon">
          <i className="fa fa-line-chart"></i>
        </div>
        <div className="stat-nums m-1"><b>{number}</b></div>
        <div className="stats-bar m-1"></div>
      </div>
    </div>
  );
}

/* ================== Dashboard ================== */
export default function Home() {

  const userType = localStorage.getItem("userType");
  const username = localStorage.getItem("email");

  const [members, setMembers] = useState([]); // MEMBERS table (mentors)
  const [clients, setClients] = useState([]); // USERS table (clients)
  const [keys, setKeys] = useState([]);

  const [totalMentors, setTotalMentors] = useState(0); // ✅ NEW
  const [totalClients, setTotalClients] = useState(0);
  const [totalKeys, setTotalKeys] = useState(0);

  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [logging, setLogging] = useState(false);
  const [diaglogueID] = useState("msg13");

  useEffect(() => {

    /* ===== LICENSE KEYS ===== */
    axios.post(APIurl, {
      cmd: "getallkeys",
      email: username,
      userType: userType
    })
    .then(res => {
      if (res.data.success) {
        setKeys(res.data.data);
        setTotalKeys(res.data.data.length);
      } else {
        setLogingmsg(res.data.data);
        setColors("bg-danger text-white");
      }
    })
    .catch(() => {
      setLogingmsg("Could not load License Keys");
      setColors("bg-danger text-white");
    });

        /* ===== TOTAL CLIENTS ===== */
    axios.post(APIurl, {
      cmd: "getallusers",
      username: username,
      userType: userType
    })
    .then(res => {
      if (res.data.success) {
        setClients(res.data.data);
        setTotalClients(res.data.data.length);
      } else {
        setLogingmsg(res.data.data);
        setColors("bg-danger text-white");
      }
    })
    .catch(() => {
      setLogingmsg("Could not load Total Clients");
      setColors("bg-danger text-white");
    });


    /* ===== OWNER → MEMBERS ===== */
    if (userType === "owner") {
      axios.post(APIurl, { cmd: "getallmembers" })
        .then(res => {
          if (res.data.success) {
            setMembers(res.data.data);
            setTotalMentors(res.data.data.length); // ✅ FIX
          } else {
            setLogingmsg(res.data.data);
            setColors("bg-danger text-white");
          }
          setLogging(true);
        })
        .catch(() => {
          setLogingmsg("Could not load members");
          setColors("bg-danger text-white");
          setLogging(true);
        });
    }

    /* ===== MENTOR → CLIENTS ===== */
    if (userType !== "owner") {
      axios.post(APIurl, {
        cmd: "getallusers",
        username: username
      })
      .then(res => {
        if (res.data.success) {
          setClients(res.data.data);
          setTotalClients(res.data.data.length);
        } else {
          setLogingmsg(res.data.data);
          setColors("bg-danger text-white");
        }
        setLogging(true);
      })
      .catch(() => {
        setLogingmsg("Could not load clients");
        setColors("bg-danger text-white");
        setLogging(true);
      });
    }

  }, [userType, username]);

  /* ================== CARDS ================== */

  // 🔵 OWNER → 3 cards
  const ownerCards = [
    { id: 1, title: "Total Mentors", number: totalMentors }, // ✅ NEW
    { id: 2, title: "Total Clients", number: totalClients },
    { id: 3, title: "License Keys", number: totalKeys }
  ];

  // 🟢 MENTOR → 2 cards
  const mentorCards = [
    { id: 1, title: "Total Clients", number: totalClients },
    { id: 2, title: "License Keys", number: totalKeys }
  ];

  /* ================== TABLE CONFIGS ================== */

  // OWNER (Members)
  const ownerHeaders = [
    { id: 1, name: "ID" },
    { id: 2, name: "Member Type" },
    { id: 3, name: "Full Names" },
    { id: 4, name: "Trading Name" },
    { id: 5, name: "Email" },
    { id: 6, name: "Cellphone" },
    { id: 7, name: "Status" },
    { id: 8, name: "Manage" }
  ];

  const ownerButtons = [
    { id: 1, title: "Export CSV", path: "exportmembers" },
    { id: 2, title: "Add Mentor", path: "register" }
  ];

  // MENTOR (Clients)
  const mentorHeaders = [
    { id: 1, name: "ID" },
    { id: 2, name: "Trade Name" },
    { id: 3, name: "Email" },
    { id: 4, name: "Status" },
    { id: 5, name: "Manage" }
  ];

  const mentorButtons = [
    { id: 1, title: "Add Client/User", path: "adduser" },
    { id: 2, title: "Export", path: "exportclients" }
  ];

  return (
    <>
      {logging && (
        <MSGDialogue
          msg={loginmsg}
          id={diaglogueID}
          colors={colors}
        />
      )}

      <div className="mr-0 ml-0 p-2 mt-2 mb-0">
        <h3>Dashboard</h3>
      </div>
      <EAAdviserInfo />

      {/* ===== Cards ===== */}
      <Container fluid className="d-flex flex-row mt-2 w-100 home-cards">
        {(userType === "owner" ? ownerCards : mentorCards).map(card => (
          <DashCards
            key={card.id}
            title={card.title}
            number={card.number}
          />
        ))}
      </Container>

      {/* ===== Table ===== */}
      {userType === "owner" ? (
        <TableUser
          name="Members"
          table_headers={ownerHeaders}
          members={members}
          buttons={ownerButtons}
          edit="/editmember"
          delete="/memberdelete"
        />
      ) : (
        <TableUser
          name="Clients"
          table_headers={mentorHeaders}
          members={clients}
          buttons={mentorButtons}
          edit="/editclient"
          delete="/clientdelete"
        />
      )}
    </>
  );
}
